/**
 * 5 캐릭터 정의 (spec §4.6). v1 placeholder: color swatch + name.
 * v2에서 픽셀 아트 스프라이트로 교체.
 */
import type { PersonalityName } from '@/gto/types';

export type CharacterDef = {
  codename: PersonalityName;
  displayName: string;
  /** Tailwind `bg-char-*` utility class for M5 placeholder. */
  swatchClass: string;
  blurb: string;
};

export const CHARACTERS: Readonly<Record<PersonalityName, CharacterDef>> = {
  VOID: {
    codename: 'VOID',
    displayName: 'VOID',
    swatchClass: 'bg-char-void',
    blurb: '우주 고양이 — 타이트 솔리드',
  },
  GRIM: {
    codename: 'GRIM',
    displayName: 'GRIM',
    swatchClass: 'bg-char-grim',
    blurb: '해골 카우보이 — 어그레시브',
  },
  PALE: {
    codename: 'PALE',
    displayName: 'PALE',
    swatchClass: 'bg-char-pale',
    blurb: '창백한 유령 — 루즈 패시브',
  },
  JEST: {
    codename: 'JEST',
    displayName: 'JEST',
    swatchClass: 'bg-char-jest',
    blurb: '광대 인형 — 매니악',
  },
  ORACLE: {
    codename: 'ORACLE',
    displayName: 'ORACLE',
    swatchClass: 'bg-char-oracle',
    blurb: '후드 예언자 — 퓨어 GTO',
  },
};

export const CHARACTER_ORDER: ReadonlyArray<PersonalityName> = [
  'VOID',
  'GRIM',
  'PALE',
  'JEST',
  'ORACLE',
];

/**
 * Map a playerId (`p1`..`p5`) to its canonical personality codename.
 * Pinned to the id so tournament eliminations don't shift the surviving
 * seats' codenames. Safe for `p0` (hero) — returns VOID fallback but
 * callers typically filter hero out before calling.
 */
export function codenameForPlayerId(playerId: string): PersonalityName {
  const raw = Number(playerId.slice(1));
  const idx = Number.isFinite(raw) ? raw - 1 : 0;
  const n = CHARACTER_ORDER.length;
  return (CHARACTER_ORDER[((idx % n) + n) % n] ?? 'VOID') as PersonalityName;
}
